/* Wallpaper variant picker behaviours (main-product-wallpaper template only).
   Uses document-level delegation because the <variant-selects> element is
   swapped out by product-info.js on every option change. */
(function () {
  function findMeasureTarget(anchor) {
    let target = null;
    if (anchor && anchor !== '#') {
      try {
        target = document.querySelector(anchor);
      } catch (error) {
        target = null;
      }
    }
    if (!target) target = document.querySelector('[data-how-to-measure]');
    if (!target) {
      target = Array.from(document.querySelectorAll('h1, h2, h3, h4')).find(function (heading) {
        return /how\s+to\s+measure\s+your\s+wall/i.test(heading.textContent);
      });
    }
    return target || null;
  }

  document.addEventListener('click', function (event) {
    const measureLink = event.target.closest('[data-wp-measure-link]');
    if (measureLink) {
      const target = findMeasureTarget(measureLink.getAttribute('href'));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
})();
